// Hierarchy level constants
export const FIRST_LEVEL = 0;
export const SECOND_LEVEL = 1;
export const THIRD_LEVEL = 2;
export const LAST_LEVEL = 2;

// Page and value constants
export const INITIAL_PAGE = 1;
export const SINGLE_VALUE = 1;
export const ADD_ONE_LEVEL = 1;

// Timeout constants
export const CLOSE_SUBMENU_TIMEOUT = 50;
export const SET_SUBMENU_TIMEOUT = 10;

// Math constants
export const RANDOM_NUMBER_MULTIPLIER = 1000000;

// Pagination and display constants
export const OUTLETS_PER_PAGE = 10;
export const TERMINALS_TO_SHOW = 15;

